/**
 * @generated SignedSource<<cb1bd03cc3323075d2b5da1376d78891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarEditArchiveMutation$variables = {
  calendarId: string;
};
export type CalendarEditArchiveMutation$data = {
  readonly store: {
    readonly calendar: {
      readonly archive: {
        readonly id: string;
        readonly isArchived: boolean;
      };
    };
  };
};
export type CalendarEditArchiveMutation = {
  response: CalendarEditArchiveMutation$data;
  variables: CalendarEditArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
          }
        ],
        "concreteType": "StoreCalendarMutation",
        "kind": "LinkedField",
        "name": "calendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isArchived",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarEditArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarEditArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c77bba033b00c833bb38d77b59a1b47",
    "id": null,
    "metadata": {},
    "name": "CalendarEditArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarEditArchiveMutation(\n  $calendarId: ID!\n) {\n  store {\n    calendar(calendarId: $calendarId) {\n      archive {\n        id\n        isArchived\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "758117b9afdcced70b80efc758ce433b";

export default node;
